import React, { useRef } from "react";

import "./index.css";
import { removeHTML } from "../../utils";
import { useNavigate } from "react-router-dom";
import { DEFAULT_HEADER_DATA } from "../../utils/state";
import { useTheme } from "../../contexts/ThemeContext";
import { HeaderSkeleton } from "./skeleton";
import defaultBanner from "./assets/Banner_01.png";
/* import defaultBanner from "./assets/img-interior25.jpg"; */
import iconoCapacitaciones from "../../assets/icons/icono_capacitaciones.png";
import { useConfig } from "../../contexts/config";
import { useIsMobile } from "../../hooks/useIsMobile";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, Autoplay } from "swiper/modules";

import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";

/* to work on */
export const HeaderCourses = ({ moodle, lang }) => {
  const theme = useTheme();
  let { config } = useConfig();
  const isMobile = useIsMobile();
  const header = useRef(null);
  /*   const banner = React.useRef(null) */
  const [state, setState] = React.useState(DEFAULT_HEADER_DATA);
  const navigation = useNavigate();
  console.log(config);

  React.useEffect(() => {
    if (moodle.courses && moodle.courses.length > 0) {
      setTimeout(() => {
        setState({
          course: moodle.courses[0],
          text: removeHTML(moodle.courses[0].summary),
        });
      }, 700);
    }
  }, [moodle]);

  /*   React.useEffect(() => {
    if (moodle.courses && moodle.courses.length > 0) {
      if (header.current) {
        console.log(header.current)
        header.current.style.backgroundImage = `url(${defaultBanner})`;
         header.current.style.backgroundColor = "#9db1d1" : "#445269"; 
      }
       moodle
        .getBanner(moodle.courses[0].id)
        .then((banner) => {
          console.log(defaultBanner);
          
          // banner y color del banner se comenta y se lleva arriba el código para que no espere al getBanner y cambie de inmediato el color
          if (banner && header.current) { 
           
          } else if (!banner && header.current) {

          } 
          
        })
        .catch((err) => console.log(err)); 
    }
  }, [moodle.courses, theme.mode]); */

  /*     React.useEffect(() => {
    let item = moodle.courses[0];
    if (item?.overviewfiles?.length > 0) {
      let imgurl = moodle.getCourseImg(item);
      header.current.style.backgroundImage = `url(${imgurl})`;
    }
  }, []); */

  // Determine if carousel should be used based on config
  // Let's assume the config provides an array of banners: config.carousel_banners
  // Example expected structure: config.carousel_banners = [{ id: 1, image: 'url', title: '...', text: '...' }]
  config = {
    ...config,
    carousel_banners: config?.carousel_banners ?? [
      {
        id: 0,
        image: "images/Banner_01.jpg",
        title: "El crecimiento de la empresa comienza contigo.",
        text: "",
        button_text: "Más información",
        button_link: "",
      },
      {
        id: 1,
        image: "images/Banner_02.jpg",
        title: "Por tí, por las pymes, por Chile.",
        text: "",
        button_text: "Ver progreso",
        button_link: "/listcourses/progress"
      },
      {
        id: 2,
        image: "images/Banner_03.jpg",
        title: "Energía que impulsa familias, negocios y sueños.",
        text: "",
        button_text: "Ingresar",
        button_link: "",
      },
    ],
  };

  const useCarousel = config?.carousel_banners && config.carousel_banners.length > 0;

  const handleNavigation = () => navigation(`/detailcourse/${state.course.id}`);

  return (
    <>
      {lang && (
        <div style={{ paddingTop: isMobile ? 45 : 80 }}>
          {useCarousel ? (
            <div style={{ position: "relative" }}>
            <Swiper
              modules={[Navigation, Pagination, Autoplay]}
              spaceBetween={0}
              slidesPerView={1}
              navigation={false}
              loop={true}
              pagination={{ clickable: true }}
              autoplay={{ delay: 5000 }}
              className="header-carousel"
              style={{
                "--swiper-pagination-bg-color": theme.colors.backgroundColorBannerBtn,
                "--swiper-pagination-txt-color": theme.mode === "light" ? "#16232c" : "#fff",
              }}
            >
              {config.carousel_banners.map((banner, index) => (
                <SwiperSlide key={index}>
                  <header
                  className="h-[350px] tablet:h-[550px]"
                    style={{
                      padding: "40px 0",
                      minHeight: 350,
                      backgroundColor: "#52217d22",
                      backgroundBlendMode: "multiply",
                      backgroundImage: `url(${banner.image || defaultBanner})`,
                      backgroundSize: "cover",
                      backgroundPosition: "center",
                    }}
                  >
                    <div className="container mar">
                      <div className="col-md-12">
                        <div className="row">
                          <div className="col-md-8">
                            <h1 className="text-white text-4xl tablet:!text-7xl font-[900] max-w-[50rem]" style={{ padding: 0 }}>
                              {banner.title || state.course?.fullname}
                            </h1>
                            {banner.text && <p className="text-generico-res">{banner.text}</p>}
                            {banner.button_text && banner.button_link && (
                              <div style={{ marginTop: "1.5rem" }}>
                                <button
                                  type="button"
                                  className="flex items-center justify-center gap-2 py-2 px-6 transition-transform duration-300 ease-in-out transform hover:scale-105"
                                  style={{
                                    backgroundColor: "#fff",
                                    border: "1px solid #FE5100",
                                    borderRadius: "9999px",
                                    color: "#FE5100",
                                  }}
                                  onClick={() => navigation(banner.button_link)}
                                >
                                  <img src={iconoCapacitaciones} alt="" style={{ width: 18, height: 18 }} />
                                  <span className="font-semibold">
                                    {banner.button_text}
                                  </span>
                                </button>
                              </div>
                            )}
                          </div>
                          <div className="col-md-4 pos-img"></div>
                        </div>
                      </div>
                    </div>
                  </header>
                </SwiperSlide>
              ))}
            </Swiper>
            <svg
              style={{ position: "absolute", bottom:-2, left: 0, width: "100%", zIndex: 10, display: "block" }}
              viewBox="0 0 1440 120"
              preserveAspectRatio="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path d="M0,100 C480,115 1008,120 1440,0 L1440,120 L0,120 Z" fill="#ffffff" />
            </svg>
            </div>
          ) : (
            <div style={{ position: "relative" }}>
            <header
              style={{
                padding: "20px 0",
                minHeight: 450,
                backgroundColor: "#52217d44", //theme.mode === "light" ? theme.colors.secondary_light : theme.colors.secondary_light,
                backgroundBlendMode: "multiply",
                backgroundImage: `url(${defaultBanner})`,
              }}
              ref={header}
            >
              <div className="container mar">
                <div className="col-md-12">
                  <div className="row">
                    {!state.course ? (
                      <HeaderSkeleton />
                    ) : (
                      <>
                        <div className="col-md-8">
                          <h1 className="tit-principal  font-bold" style={{ padding: 0 }}>
                            {state.course.fullname}
                          </h1>
                          <p className="text-generico"></p>
                          <p className="text-generico-res">{state.text}</p>
                          <div style={{ marginTop: "1.5rem" }}>
                            <button
                              type="button"
                              className="flex items-center justify-center gap-2 py-2 px-6 transition-transform duration-300 ease-in-out transform hover:scale-105"
                              style={{
                                backgroundColor: "transparent",
                                border: "2px solid #FE5100",
                                borderRadius: "9999px",
                                color: "#FE5100",
                              }}
                              onClick={handleNavigation}
                            >
                              <img src={iconoCapacitaciones} alt="" style={{ width: 18, height: 18 }} />
                              <span className="font-semibold">
                                {lang["Home"].course_btn}
                              </span>
                            </button>
                          </div>
                        </div>
                      </>
                    )}
                    <div className="col-md-4 pos-img"></div>
                  </div>
                </div>
              </div>
            </header>
            <svg
              style={{ position: "absolute", bottom: 0, left: 0, width: "100%", zIndex: 10, display: "block" }}
              viewBox="0 0 1440 120"
              preserveAspectRatio="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path d="M0,100 C480,115 1008,120 1440,0 L1440,120 L0,120 Z" fill="#ffffff" />
            </svg>
            </div>
          )}
        </div>
      )}
    </>
  );
};
